// NPM
import _ from "lodash"
import React, { useState } from "react"

// Form Components
import Dropdown from "src/components/Shared/FormFields/Dropdown"
import TextField from "src/components/Shared/FormFields/TextField"
import { countries, regions } from "./locations.json"

const submissionUrl = "https://api.voxpoplabs.dev/signup"

const SignupForm = ({ signupForm, signupFormSection, lang = "en" }) => {
  const [formData, setFormData] = useState({})
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [formSubmittedError, setFormSubmittedError] = useState(false)

  const setFormDataField = (formField, value) => {
    setFormData({
      ...formData,
      [formField.uuid]: {
        fieldName: formField.name,
        value,
      },
    })
  }

  const submitForm = async e => {
    e.preventDefault()

    const body = {
      email: formData.email?.value,
      country: formData.country?.value,
      region: formData.region?.value,
      firstName: formData.name?.value,
      language: lang,
    }

    const response = await fetch(submissionUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })

    if (response.status === 200) {
      setFormSubmitted(true)
    } else {
      setFormSubmittedError(true)
      setFormSubmitted(false)
    }
  }

  if (!signupForm) {
    return null
  }

  const formSubmittedText =
    lang == "en"
      ? (
          signupFormSection.miscText.find(
            mt => mt.uuid === "formSubmitted_text",
          ) || {}
        ).text
      : "Merci!"

  const formSubmittedErrorText =
    lang == "en"
      ? "An error occurred while submitting the form."
      : "Une erreur est survenue lors de la soumission du formulaire."

  return (
    <div className="SignupForm">
      <form onSubmit={submitForm}>
        {_.get(signupForm, "fields", []).map((formField, formFieldIndex) => {
          switch (formField.strapi_component) {
            case "form.text-field":
              return (
                <TextField
                  formField={formField}
                  key={`FormField-${formFieldIndex}`}
                  onChange={value => setFormDataField(formField, value)}
                  value={_.get(formData, `${formField.uuid}.value`, "")}
                  required={formField.uuid == "email"}
                />
              )

            case "form.dropdown":
              if (formField.uuid == "country") {
                formField = {
                  ...formField,
                  options: [...countries].map((country, i) => ({
                    label: country,
                    value: country,
                    order: i,
                  })),
                }
              }

              if (formField.uuid == "region") {
                if (regions[formData["country"]?.value]) {
                  formField = {
                    ...formField,
                    options: [...regions[formData["country"]?.value]].map(
                      (region, i) => ({
                        label: region,
                        value: region,
                        order: i,
                      }),
                    ),
                  }
                } else {
                  return null
                }
              }

              return (
                <Dropdown
                  formField={formField}
                  key={`FormField-${formFieldIndex}`}
                  onChange={value => setFormDataField(formField, value)}
                  value={_.get(formData, `${formField.uuid}.value`, "")}
                  required={
                    formField.uuid == "country" || formField.uuid == "region"
                  }
                />
              )

            default:
              return null
          }
        })}

        <button className="SignupForm__submit black-button" role="submit">
          <span>{signupForm.submitText}</span>
          <span className="icon">
            <img
              src={require("src/images/icons/arrow-right-white.png").default}
            />
          </span>
        </button>
      </form>

      {formSubmitted && (
        <div className="SignupForm__form-submitted">
          <p>{formSubmittedText}</p>
        </div>
      )}

      {formSubmittedError && (
        <div className="SignupForm__form-submitted">
          <p style={{ textWrap: "balance" }}>{formSubmittedErrorText}</p>
          <button
            className="error-button"
            onClick={() => setFormSubmittedError(false)}
          >
            {lang == "en" ? <span>Try again</span> : <span>Réessayer</span>}
          </button>
        </div>
      )}
    </div>
  )
}

export default SignupForm
